import { type ReactElement } from 'react';
import SolutionPageLayout from '../../components/features/SolutionPageLayout';

export default function Kleinunternehmer(): ReactElement {
  return (
    <SolutionPageLayout
      badge="Für Kleinunternehmer"
      title="Buchhaltung für Kleinunternehmer – optimiert für §19 UStG"
      subtitle="Als Kleinunternehmer profitieren Sie von vereinfachter Buchhaltung. Saldify ist perfekt auf die Kleinunternehmerregelung abgestimmt."
      heroImage="/screenshots/app-rechnungen.webp"
      heroImageAlt="Rechnungen ohne Umsatzsteuerausweis nach § 19 UStG in Saldify"
      introTitle="Speziell für die Kleinunternehmerregelung"
      introText="Als Kleinunternehmer nach §19 UStG haben Sie besondere Anforderungen: Keine Umsatzsteuer auf Rechnungen, aber trotzdem professionelle Buchhaltung. Saldify unterstützt Sie dabei mit speziellen Funktionen."
      introBullets={[
        'Rechnungen ohne Umsatzsteuer – rechtssicher formuliert',
        'Automatischer Hinweis auf Kleinunternehmerregelung',
        'Übersicht über Ihre Umsatzgrenze (22.000€)',
        'Warnung bei Annäherung an die Grenze',
      ]}
      benefits={[
        {
          title: 'Rechtssichere Rechnungen',
          description: 'Automatischer Hinweis auf §19 UStG – Ihre Rechnungen sind immer korrekt.',
        },
        {
          title: 'Umsatzgrenze im Blick',
          description: 'Saldify zeigt Ihnen, wie nah Sie an der 22.000€-Grenze sind.',
        },
        {
          title: 'Einfache EÜR',
          description: 'Die Einnahmen-Überschuss-Rechnung wird automatisch erstellt.',
        },
        {
          title: 'Keine Umsatzsteuer-Komplexität',
          description: 'Verzichten Sie auf komplizierte Umsatzsteuer-Berechnungen – Saldify passt sich an.',
        },
        {
          title: 'Wachstum vorbereiten',
          description: 'Wenn Sie die Grenze überschreiten, sind Sie mit Saldify schon bestens vorbereitet.',
        },
        {
          title: 'Steuerberater-Export',
          description: 'Ihre Daten sind perfekt für den Steuerberater aufbereitet.',
        },
      ]}
      useCases={[
        {
          title: 'Nebengewerbe',
          description: 'Perfekt für den Start neben dem Hauptberuf – einfach und übersichtlich.',
        },
        {
          title: 'Online-Handel',
          description: 'Produkte auf Etsy, eBay & Co. verkaufen und die Buchhaltung im Griff haben.',
        },
        {
          title: 'Dienstleister',
          description: 'Nachhilfe, Handwerk, Beratung – professionell abrechnen ohne Steuerstress.',
        },
        {
          title: 'Kreative',
          description: 'Fotografie, Design, Musik – konzentrieren Sie sich auf Ihre Kunst.',
        },
      ]}
      features={[
        'Kleinunternehmer-konforme Rechnungen',
        'Umsatzgrenze-Tracking (22.000€)',
        'Automatischer §19 UStG Hinweis',
        'EÜR für die Steuererklärung',
        'Belegerfassung per App',
        'Kundenverwaltung',
        'Gewinn- und Umsatz-Übersicht',
        'Export für Steuerberater',
      ]}
      recommendedPlan={{
        name: 'Plus',
        price: '9€/Monat',
        description: 'Optimal für Kleinunternehmer: Alle Funktionen für die vereinfachte Buchhaltung.',
      }}
      testimonial={{
        quote: 'Endlich eine Software, die Kleinunternehmer versteht! Der automatische §19-Hinweis auf den Rechnungen hat mir schon viel Ärger erspart.',
        author: 'Thomas K.',
        role: 'Nebenberuflich Selbstständig',
        company: 'Online-Shop Betreiber',
      }}
    />
  );
}
